import { gql } from '@apollo/client';

const GET_ORG_UNITS_SHARED_REPORTS_WITH_FDA = gql`
  query GetOrgUnitSharedReportsWithFda($orgUnitId: Int!) {
    mddapOrgUnitFdaSharing(orgUnitId: $orgUnitId) {
      SharedPerformanceReports {
        MddapCheckpointPerformanceItemId
      }
      SharedDetailedAppraisalReports {
        AppraisalId
      }
    }
  }
`;

export default GET_ORG_UNITS_SHARED_REPORTS_WITH_FDA;
